module.exports = {
      id: "whatsappicon-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#whatsappicon",
      toString: function () {
        return this.url;
      }
    }